import {
    MAX_HOSPITALITY_TICKETS, MAX_HOSPITALITY_TICKETS_AVAILABLE,
    MAX_STANDART_TICKETS, MAX_STANDART_TICKETS_AVAILABLE, MAX_STANDART_TICKETS_JUNIOR_AVAILABLE, PRODUCT_TAG_ADULT, PRODUCT_TAG_JUNIOR,
    PRODUCT_TAG_YOUTH, PRODUCT_TYPE_EXTRAS,
    PRODUCT_TYPE_HOSPITALITY,
    PRODUCT_TYPE_TICKET,
    PRODUCT_TAG_SWING_BADGE,
    MAX_SWING_BADGE_AVAILABLE,
    PRODUCT_TAG_SWING_BADGE_GUEST,
    PRODUCT_TAG_SWING_BADGE_ADDITIONAL_GUEST,
    MAX_SWING_BADGE_GUEST_AVAILABLE,
    MAX_SWING_BADGE_ADDITIONAL_GUEST_AVAILABLE
} from './constants';

export default class ValidationHelper {
    static getPreparedProductsList(products) {
        const totalSelected = products
            .filter((ticket) => ticket.tag === PRODUCT_TAG_ADULT || ticket.tag === PRODUCT_TAG_YOUTH)
            .reduce((total, curProducts) => (curProducts.quantity ? total + curProducts.quantity : total), 0);

        products
            .sort((a, b) => a.sortOrder - b.sortOrder)
            .forEach((product) => {
                if (product.type === PRODUCT_TYPE_HOSPITALITY ||
                    product.type === PRODUCT_TYPE_EXTRAS
                ) {
                    switch (product.tag) {
                        case PRODUCT_TAG_SWING_BADGE:
                            product.maxQuantity = MAX_STANDART_TICKETS_AVAILABLE;
                            product.maxAvailable = MAX_SWING_BADGE_AVAILABLE;
                            break;
                        case PRODUCT_TAG_SWING_BADGE_GUEST:
                            product.maxQuantity = MAX_STANDART_TICKETS_AVAILABLE;
                            product.maxAvailable = MAX_SWING_BADGE_GUEST_AVAILABLE;
                            break;
                        case PRODUCT_TAG_SWING_BADGE_ADDITIONAL_GUEST:
                            product.maxQuantity = MAX_STANDART_TICKETS_AVAILABLE;
                            product.maxAvailable = MAX_SWING_BADGE_ADDITIONAL_GUEST_AVAILABLE;
                            break;
                        default:
                            product.maxQuantity = MAX_HOSPITALITY_TICKETS;
                    }
                } else {
                    product.maxQuantity = MAX_STANDART_TICKETS;
                }

                if (product.type === PRODUCT_TYPE_TICKET ||
                    product.type === PRODUCT_TYPE_HOSPITALITY
                ) {
                    product.maxAvailable = 0;
                    let totalAvailable = 0;

                    if (product.type === PRODUCT_TYPE_TICKET) {
                        totalAvailable = MAX_STANDART_TICKETS_AVAILABLE - totalSelected - MAX_STANDART_TICKETS_JUNIOR_AVAILABLE;
                    }

                    if (product.type === PRODUCT_TYPE_HOSPITALITY) {
                        totalAvailable = MAX_HOSPITALITY_TICKETS_AVAILABLE - totalSelected;
                    }

                    product.maxAvailable = product.quantity + totalAvailable;

                    if (product.tag === PRODUCT_TAG_JUNIOR) {
                        product.maxQuantity = MAX_STANDART_TICKETS_JUNIOR_AVAILABLE;
                        product.maxAvailable = (totalSelected * 2 > MAX_STANDART_TICKETS_JUNIOR_AVAILABLE ? MAX_STANDART_TICKETS_JUNIOR_AVAILABLE : totalSelected * 2);
                    }
                }
            });

        return products;
    }

    static isNeedResetJunior(updatedProductType, updatedProductTag) {
        return (updatedProductType === PRODUCT_TYPE_TICKET &&
                (updatedProductTag === PRODUCT_TAG_ADULT || updatedProductTag === PRODUCT_TAG_YOUTH)) ||
            (updatedProductType === PRODUCT_TYPE_EXTRAS &&
                (updatedProductTag === PRODUCT_TAG_SWING_BADGE));
    }

    static resetJuniorProducts(productGroups, setToZero = false) {
        Object.keys(productGroups).forEach((groupId) => {
            const basketProductGroup = productGroups[groupId];

            const juniorProductsList = basketProductGroup.products.filter((product) =>
                (product.type === PRODUCT_TYPE_TICKET &&
                product.tag === PRODUCT_TAG_JUNIOR) ||
                (product.type === PRODUCT_TYPE_EXTRAS &&
                product.tag === PRODUCT_TAG_SWING_BADGE_GUEST));

            juniorProductsList.forEach((juniorProduct) => {
                const basketJuniorProduct = basketProductGroup.products.find((curBasketProduct) =>
                    curBasketProduct.type === juniorProduct.type &&
                    curBasketProduct.tag === juniorProduct.tag);

                if (basketJuniorProduct) {
                    if (setToZero) {
                        basketJuniorProduct.quantity = 0;
                    } else {
                        basketJuniorProduct.quantity = 1;
                    }
                }
            });
        });
    }
}
